// extracted by mini-css-extract-plugin
export default {"SearchBox":"SearchBox_4B+jQ","closeBtn":"closeBtn_sblYM"};